<template>
  <ul>
    <li
      v-for="(link, index) in isClean ? profileMenuCleanLinks : profileMenuLinks"
      :key="index"
      class="profile-link"
    >
      <a
        :class="{ current: link.current }"
        :href="link.href"
      >
        {{ link.label }}
      </a>
    </li>
    <li class="log-out">
      <a
        href="#"
        @click="logOut()"
      >
        {{ $t('header.preHeader.userProfile.logout') }}
      </a>
    </li>
  </ul>
</template>

<script>
  import { mapState } from 'vuex'
  import PaxLogout from 'services/AirBaltic/Pax/Logout'

  export default {
    props: {
      isClean: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      ...mapState({
        selectedLang: (state) => state.main.selectedLang,
        profileMenuLinks: (state) => state.header.profileMenuLinks,
        profileMenuCleanLinks: (state) => state.header.profileMenuCleanLinks
      })
    },
    methods: {
      callback() {
        this.$store.dispatch('main/user/clearUserData')
        this.$emit('closeFlyout')
      },
      logOut() {
        new PaxLogout().logoutUser(this.callback)
        this.$emit('logout')
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .manage-profile {
    ul {
      z-index: 1;
      position: absolute;
      padding-top: 7px;
      width: 180px;
      background-color: #ffffff;
      list-style: none;
      box-shadow: 0 2px 6px 0 hexToRGBA(#000000, 0.23);

      @include bp-mobile {
        padding: 0 20px;
        width: 100%;
        height: calc(100% - 62px);
        background: $blue-grey;
        box-shadow: none;
      }
    }

    li {
      line-height: 18px;

      @include bp-mobile {
        border-bottom: 1px solid $blue-grey-dark;
        line-height: 49px;
      }

      &.log-out {
        margin-top: 7px;
        border-top: 1px solid #f6f6f6;
        font-size: rem(12, 16);
        font-weight: 700;
        line-height: 39px;

        @include bp-mobile {
          margin-top: 0;
          border: none;
          border-bottom: 1px solid $blue-grey-dark;
          font-size: rem(14, 16);
          font-weight: 400;
          line-height: 49px;
        }

        a {
          padding: 0 20px;

          @include bp-mobile {
            padding: 0;
          }

          &:before {
            content: $icon-logout-thin-medium;
            @include icon-font-thin();
            position: relative;
            top: 1px;
            margin-right: 10px;
            font-size: rem(16, 16);
            transform: rotate(180deg);
          }
        }
      }

      a {
        display: block;
        padding: 7px 20px;
        text-decoration: none;
        color: $blue-dark;

        @include bp-mobile {
          padding: 0;
          color: #ffffff;
        }

        &:hover {
          color: $green-dark;

          @include bp-mobile {
            color: $gray-active-text-color;
          }
        }
      }
    }
  }

  .manage-profile-white {
    width: 100%;
    list-style: none;
    text-align: left;

    @include bp-tablet-only {
      padding: 18px 26px;
    }

    @include bp-mf-tablet {
      padding: 18px 23px;
      border-bottom: 1px solid $grey-border;
      background-color: #f1f1f3;
    }

    @include bp-tablet-min-height {
      position: absolute;
      z-index: 3;
      top: 34px;
      left: calc(50% - 80px);
      width: 190px;
      padding: 10px 20px;
      border-radius: 6px;
      background-color: #ffffff;
    }

    .log-out {
      a {
        font-size: rem(16, 16);

        &:before {
          content: $icon-logout-thin;
          @include icon-font-thin();
          margin-right: 17px;
          vertical-align: middle;
          font-size: rem(16, 16);
        }
      }
    }

    a {
      font-size: rem(16, 16);
      font-weight: 400;
      line-height: rem(24, 16);
      color: $blue-dark;
      padding: 8px 0;
      display: flex;
      align-items: center;
      text-decoration: none;
      white-space: normal;
      text-align: left;

      @include bp-mf-tablet {
        display: block;
        padding: 12px 0;
      }

      &:hover {
        color: #aeaeae;
      }

      &.current {
        position: relative;
        color: $green-dark;

        &:before {
          content: '';
          position: absolute;
          top: calc(50% - 14px);
          left: -23px;
          display: block;
          width: 2px;
          height: 27px;
          background-color: $green-dark;

          @include bp-mf-tablet {
            display: none;
          }
        }
      }
    }
  }
</style>
